// src/components/admin/scheduling/timeUtils.js

export function formatTimeFromMinutes(mins) {
  const h24 = Math.floor(mins / 60);
  const m = mins % 60;
  const ampm = h24 >= 12 ? "PM" : "AM";
  const h12 = ((h24 + 11) % 12) + 1;
  const mm = String(m).padStart(2, "0");
  return `${h12}:${mm} ${ampm}`;
}

export function minutesFromDate(d) {
  return d.getHours() * 60 + d.getMinutes();
}

export function buildTimeOptions(startMin, endMin, step = 5) {
  const arr = [];
  for (let t = startMin; t <= endMin; t += step) arr.push(t);
  return arr;
}

// Convert minutes-from-midnight to "HH:MM" string (for <input type="time">)
export function minutesToTimeStr(min) {
  const safeMin = Math.max(0, Math.round(min || 0));
  const h = Math.floor(safeMin / 60) % 24;
  const m = safeMin % 60;
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
}

// Convert "HH:MM" string back to minutes-from-midnight
export function timeStrToMinutes(str) {
  if (!str) return 0;
  const [hStr, mStr] = str.split(":");
  const h = parseInt(hStr, 10) || 0;
  const m = parseInt(mStr, 10) || 0;
  return h * 60 + m;
}